var scope_0 = require('/home/runner/work/dr-todd-chiro/dr-todd-chiro/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c9b610524cdf03ace2d603088cd8f830.js').default;
var scope_1 = require('/home/runner/work/dr-todd-chiro/dr-todd-chiro/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    